const MODAL_NAME = "setProjectPackageTypeModal";

export { MODAL_NAME };
